import React from "react";
import FormField from "../components/FormField";
import DateField from "../components/DateField";

const PARTY_OPTIONS = [
  { value: "seller", label: "فروشنده" },
  { value: "buyer", label: "خریدار" },
];

export default function Step4TransferInfo({ data, onChange }) {
  return (
    <div>
      <h2 className="text-lg font-bold text-navy">نقل و انتقال و دفترخانه</h2>
      <p className="mt-1 text-sm text-gray-500">
        مشخص کنید هزینه‌های انتقال سند بر عهده چه کسی است و انتقال در کدام
        دفترخانه انجام می‌شود.
      </p>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormField
          label="هزینه نقل و انتقال بر عهده"
          name="transferFeeBy"
          type="radio"
          value={data.transferFeeBy}
          onChange={onChange}
          options={PARTY_OPTIONS}
          required
        />
        <FormField
          label="هزینه شماره‌گذاری بر عهده"
          name="plateFeeBy"
          type="radio"
          value={data.plateFeeBy}
          onChange={onChange}
          options={PARTY_OPTIONS}
          required
        />
        <DateField
          label="تاریخ مراجعه به دفترخانه"
          name="notaryDate"
          value={data.notaryDate}
          onChange={onChange}
          
        />
        <FormField
          label="شماره دفترخانه"
          name="notaryNumber"
          value={data.notaryNumber}
          onChange={onChange}
          placeholder="مثلاً دفترخانه شماره ۲۴"
        />
        <FormField
          label="آدرس دفترخانه"
          name="notaryAddress"
          type="textarea"
          value={data.notaryAddress}
          onChange={onChange}
          placeholder="آدرس کامل دفترخانه اسناد رسمی"
          full
        />
      </div>
    </div>
  );
}
